var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLife = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.527 1H1v9h6.107V7.978h-3.58V1Zm4.544 9h2.893V1H8.071v9Zm3.858 0h2.531V6.446h2.812V4.424H14.46V3.022h3.575V1h-6.107v9Zm6.75-9v9h6.107V7.977h-3.61V6.446h2.864V4.423h-2.864V3.011h3.61V1h-6.107Z",
  fill: "#FF0A0A"
})));
export default SvgLife;